import React from 'react';
import { StyleSheet, View } from 'react-native';

import { onboardingTestIDs, Theme } from '@constants';
import { useContextNodeHandles } from '@hooks';
import { navigationService } from '@services';

import { TWCButton } from '../../focusable/TWCButton/TWCButton';
import { TWCText } from '../../primitives/TWCText/TWCText';

export const onboardingDebugItems = [
  {
    title: 'Onboarding Home',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.onboardingHomeButton,
    pageTestID: onboardingTestIDs.pages.onboardingHomePage,
  },
  {
    title: 'Onboarding Free Trial',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.onboardingFreeTrialButton,
    pageTestID: onboardingTestIDs.pages.onboardingFreeTrialPage,
  },
  {
    title: 'Sign In',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.subscriberSignInButton,
    pageTestID: onboardingTestIDs.pages.subscriberSignInPage,
  },
  {
    title: 'Sign Up',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.subscriberSignUpButton,
    pageTestID: onboardingTestIDs.pages.subscriberSignUpPage,
  },
  {
    title: 'Auth Verification',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.authVerificationButton,
    pageTestID: onboardingTestIDs.pages.authVerificationPage,
  },
  {
    title: 'Device Activation',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.deviceActivationButton,
    pageTestID: onboardingTestIDs.pages.deviceActivationPage,
  },
  {
    title: 'Welcome Back',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.subscriberWelcomeBackButton,
    pageTestID: onboardingTestIDs.pages.subscriberWelcomeBackPage,
  },
  {
    title: 'Select Plan',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.subscriptionSelectionButton,
    pageTestID: onboardingTestIDs.pages.subscriptionSelectionPage,
  },
  {
    title: 'Success',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.successButton,
    pageTestID: onboardingTestIDs.pages.successPage,
  },
  {
    title: 'Error',
    buttonTestID: onboardingTestIDs.onboardingDebugMenu.errorButton,
    pageTestID: onboardingTestIDs.pages.errorPage,
  },
];

export const OnboardingDebugSection = () => {
  const onboardingNodeHandles = useContextNodeHandles(onboardingDebugItems.map(({ buttonTestID }) => buttonTestID));

  return (
    <View style={Theme.styles.center}>
      <TWCText noTestID style={styles.onboardingDebugTitle} variant={'regularText24'}>
        {'Onboarding'}
      </TWCText>
      {onboardingDebugItems.map((item, index) => {
        const { buttonTestID, pageTestID, title } = item;
        const numberOfItems = onboardingDebugItems.length;
        const nextFocusDownHandle = index < numberOfItems - 1 ? onboardingNodeHandles[index + 1] : null;
        const nextFocusUpHandle = index > 0 ? onboardingNodeHandles[index - 1] : null;

        return (
          <TWCButton
            key={index}
            nextFocusDown={nextFocusDownHandle}
            nextFocusLeft={null}
            nextFocusRight={null}
            nextFocusUp={nextFocusUpHandle}
            style={styles.onboardingButton}
            testID={buttonTestID}
            title={title}
            onPress={() => navigationService.navigate(pageTestID)}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  onboardingButton: {
    marginBottom: Theme.px(10),
  },
  onboardingDebugTitle: {
    marginBottom: Theme.px(20),
  },
  pageTitleWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: Theme.px(20),
  },
});
